import React from 'react';
import { GridColDef, GridValueFormatterParams, GridRenderEditCellParams, gridDateComparator, GRID_DATE_COL_DEF, useGridApiContext } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { REPORT_TABLE } from '../../shared/constants';
import { Project } from '../ManageProjects/ManageProjects';
import DurationInput from './DurationInput';
import { Autocomplete, Avatar, Chip, TextField, Typography } from '@mui/material';
import { GridAlignment } from '@mui/x-data-grid';
import constants from '../../shared/constants';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Employee } from '../../redux-toolkit/reducers/allEmployeeReducer';
import { User } from '../../redux-toolkit/reducers/userReducer';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
import { ProjectMappedWithFeature } from './reports.types';
import FeatureInput from './FeatureInput';
import ThreeDotMyTeamAction from '../MyTeam/ThreeDotMyTeamAction';


function GridEditDateCell({ id, field, value }: GridRenderEditCellParams) {
	const apiRef = useGridApiContext();

	function handleChange(newValue: any) {
		apiRef.current.setEditCellValue({ id, field, value: newValue });
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				value={value}
				renderInput={(params) => <TextField {...params} />}
				onChange={handleChange}
				disableFuture
			/>
		</LocalizationProvider>
	);
}

const dateColumnType = {
	...GRID_DATE_COL_DEF,
	resizable: false,
	renderEditCell: (params: GridRenderEditCellParams) => <GridEditDateCell {...params} />
};

export const getReportsMyTeamColumnDefs = (setShowAlert:React.Dispatch<any>,setWarningMessage:React.Dispatch<any>,projects: Project[], user: User, employees: Employee[], adminReport:boolean, features?: ProjectMappedWithFeature): GridColDef[] => [
	{
		field: 'picture',
		headerName: '',
		width: 25,
		renderCell: (params: any) => (
			<Avatar sx={{ width: 24, height: 24 }} alt="avatar" src={params.value} />
		),
		filterable: false,
		hide: !(user.employeeType === constants.EMPLOYEE_TYPES.ADMIN || user.employeeType === constants.EMPLOYEE_TYPES.PROJECT_MANAGER),
	},
	{
		field: 'email',
		headerName: 'Email',
		sortable: true,
		filterable: !adminReport,
		flex: 1,
		minWidth: 150,
		hide: !(user.employeeType === constants.EMPLOYEE_TYPES.ADMIN || user.employeeType === constants.EMPLOYEE_TYPES.PROJECT_MANAGER),
		renderCell: (params: any) => {
			const filteredData = employees.filter((item: any) => item.userName === params.row.userName);
				const item = filteredData[0];
			return <Typography>{item.firstName} {item.lastName}</Typography>;
		}
	},
	{
		field: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_DATE.name,
		...dateColumnType,
		headerName: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_DATE.header,
		editable: false,
		filterable: false,
		minWidth: 180,
		valueFormatter(params: GridValueFormatterParams) {

			const activityDate = typeof params.value === 'string'
				? parseInt(params.value)
				: params.value;
			return dayjs.utc(activityDate).tz('Asia/Kolkata').format('DD-MM-YYYY');
		},
		sortComparator: gridDateComparator,
	},
	{
		field: REPORT_TABLE.PROJECT_FIELDS.FEATURE.name,
		headerName: REPORT_TABLE.PROJECT_FIELDS.FEATURE.header,
		flex: 1,
		filterable: false,
		editable: false,
		type: 'string',
		renderEditCell(params: GridRenderEditCellParams) {

			const projectName = params.row.displayProjectName;

			return (<FeatureInput {...params} features={features} projectName={projectName} />);
		},
		minWidth: 120,
	},
	{
		field: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_TYPE.name,
		headerName: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_TYPE.header,
		type: 'singleSelect',
		valueOptions: [...REPORT_TABLE.ACTIVITIES],
		flex: 1,
		minWidth: 120,
		editable: false,
		filterable: false
	},
	{
		field: REPORT_TABLE.PROJECT_FIELDS.WORK_DESCRIPTION.name,
		headerName: REPORT_TABLE.PROJECT_FIELDS.WORK_DESCRIPTION.header,
		sortable: false,
		editable: false,
		flex: 2,
		minWidth: 200,
		filterable: false
	},
	{
		field: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_DURATION.name,
		headerName: REPORT_TABLE.PROJECT_FIELDS.ACTIVITY_DURATION.header,
		sortable: true,
		type: 'number',
		width: 80,
		editable: false,
		align: 'center' as GridAlignment,
		renderEditCell(params: GridRenderEditCellParams) {
			return <DurationInput {...params} />;
		},
		filterable: false
	},
		{
			field: REPORT_TABLE.PROJECT_FIELDS.WORK_MODE.name,
			headerName: REPORT_TABLE.PROJECT_FIELDS.WORK_MODE.header,
			sortable: false,
			type: 'singleSelect',
			valueOptions: [...REPORT_TABLE.WORK_MODE_OPTIONS],
			flex: 1,
			minWidth: 120,
			editable: true,
			filterable: false,
			},
	{
		field: 'Comment',
		headerName: 'Comment',
		type: 'boolean',
		sortable: false,
		editable: false,
		flex: 2,
		maxWidth: 90,
		renderCell: (params: any) => (
			<>
				{
				<ThreeDotMyTeamAction value={params} setShowAlert={setShowAlert} setWarningMessage={setWarningMessage}/>
				}
			</>

		),
	}
].filter((column) => column !== null);
